module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C129"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C132"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgments#page_vii"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction__The_Writer_s_Diet#page_1"
    }
  }, [_vm._v("Introduction: The Writer’s Diet")])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1__Verbal_verve#page_5"
    }
  }, [_vm._v("1. Verbal verve")])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Noun_density#page_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Noun density")])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3__Prepositional_podge#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Prepositional podge")])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__Ad_dictions#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Ad-dictions")])]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5__Waste_words#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Waste words")])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Afterword__Healthy_writing#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword: Healthy writing")])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Appendix__The_WritersDiet_Test#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: The WritersDiet Test")])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_References#page_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Index#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 66
// module chunks = 0